import { useCallback, useEffect, useState } from "react";
import { Search, Save } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";

const UserRow = ({ u, onSaved }) => {
  const [credits, setCredits] = useState(u.photo_credits);
  const update = async (patch) => {
    try {
      await api.put(`/admin/users/${u.id}`, patch);
      toast.success("Usuário atualizado");
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <tr className="border-b border-white/5 last:border-0" data-testid={`admin-user-row-${u.id}`}>
      <td className="p-4"><p className="font-semibold">{u.name} {u.role === "admin" && <span className="ml-1 rounded bg-lime-400 px-1.5 font-mono-tech text-[10px] text-black">ADMIN</span>}</p><p className="text-xs text-slate-400">{u.email}</p></td>
      <td className="p-4">{u.photos_count}</td>
      <td className="p-4">{u.paid_contests?.length || 0}</td>
      <td className="p-4">
        <div className="flex items-center gap-2">
          <Input data-testid={`admin-user-credits-${u.id}`} type="number" min="0" value={credits} onChange={(e) => setCredits(e.target.value)} className="w-20" />
          <button data-testid={`admin-user-save-credits-${u.id}`} onClick={() => update({ photo_credits: Number(credits) })} className="rounded-full border border-white/10 p-2 hover:border-cyan-400"><Save className="h-3.5 w-3.5" /></button>
        </div>
      </td>
      <td className="p-4">
        <div className="flex items-center gap-2">
          <Switch data-testid={`admin-user-ban-${u.id}`} checked={!!u.banned} disabled={u.role === "admin"} onCheckedChange={(v) => update({ banned: v })} />
          <span className={`text-xs ${u.banned ? "text-red-400" : "text-slate-500"}`}>{u.banned ? "Suspenso" : "Ativo"}</span>
        </div>
      </td>
    </tr>
  );
};

export const AdminUsers = () => {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin/users", { params: { q } }).then((r) => setItems(r.data)), [q]);
  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <div>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <h2 className="font-display text-3xl font-black uppercase">Usuários <span className="text-cyan-400">({items.length})</span></h2>
        <div className="relative w-full max-w-xs">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <Input data-testid="admin-users-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar nome ou e-mail" className="pl-9" />
        </div>
      </div>
      <div className="glass overflow-x-auto rounded-xl">
        <table className="w-full text-sm" data-testid="admin-users-table">
          <thead className="font-mono-tech text-[11px] uppercase tracking-widest text-slate-500">
            <tr className="border-b border-white/10 text-left"><th className="p-4">Usuário</th><th className="p-4">Fotos</th><th className="p-4">Inscrições</th><th className="p-4">Créditos</th><th className="p-4">Situação</th></tr>
          </thead>
          <tbody>{items.map((u) => <UserRow key={`${u.id}-${u.photo_credits}-${u.banned}`} u={u} onSaved={load} />)}</tbody>
        </table>
      </div>
    </div>
  );
};
